import React from "react";
import { saveNotesData } from "../../services/ContactNotes";
import { Typeahead } from "react-bootstrap-typeahead";
import { getDispositions } from "../../services/DispositionService";

const NOTES_CHAR_LIMIT = 1000;

const getSubDispositionByIdOrDefault = (items, id) => {
	if (!items || items.length < 1) {
		return [];
	}

	const idMatch = items.find((x) => x.subDispositionId === id);

	if (idMatch) {
		return [idMatch];
	}

	const defaultItem = items.find((x) => x.isDefault);

	if (defaultItem) {
		return [defaultItem];
	}

	return [items[0]];
};

const ContactNotes = ({ contact, contactNote, setNotesForContact, renderToastContent }) => {
	const [notes, setNotes] = React.useState("");
	const [noteCharLimit, setNoteCharLimit] = React.useState(0);

	const [dispositionOptions, setDispositionOptions] = React.useState([]);
	const [subDispositionOptions, setSubDispositionOptions] = React.useState([]);

	const [disposition, setDisposition] = React.useState([]);
	const [subDisposition, setSubDisposition] = React.useState([]);

	const contactId = contact.contactId;

	const handleNoteChange = (newNote) => {
		setNotes(newNote);
		setNoteCharLimit(NOTES_CHAR_LIMIT - newNote.length);
	};

	React.useEffect(() => {
		if (contactNote) {
			handleNoteChange(contactNote.notes);
			const dispositionMatch = dispositionOptions.find((x) => x.dispositionId === contactNote.dispositionId);
			if (dispositionMatch) {
				setDisposition([dispositionMatch]);

				const newSubDispositionOptions = dispositionMatch.subDispositions || [];
				setSubDispositionOptions(newSubDispositionOptions);

				if (contactNote.subDispositionId) {
					const newSubDisposition = getSubDispositionByIdOrDefault(
						newSubDispositionOptions,
						contactNote.subDispositionId,
					);

					setSubDisposition(newSubDisposition);
				} else {
					setSubDisposition([]);
				}
			} else {
				setDisposition([]);
				setSubDisposition([]);
			}
		}
	}, [contactNote, dispositionOptions]);

	React.useEffect(() => {
		const loadDispositions = async () => {
			try {
				const data = await getDispositions();
				setDispositionOptions(data);
			} catch {
				setDispositionOptions([]);
			}
		};

		loadDispositions();
	}, []);

	const saveNotes = React.useCallback(
		async (disposition, subDisposition, notes) => {
			try {
				const dispositionToSave = disposition?.length > 0 ? disposition[0] : {};
				const subDispositionToSave = subDisposition?.length > 0 ? subDisposition[0] : {};

				const newContactNotes = {
					notes: notes || "",
					disposition: dispositionToSave.dispositionName || "",
					dispositionId: dispositionToSave.dispositionId || "",
					subDisposition: subDispositionToSave.subDispositionName || "",
					subDispositionId: subDispositionToSave.subDispositionId || "",
				};

				await saveNotesData(newContactNotes, contactId);
				setNotesForContact(newContactNotes, contactId);

				renderToastContent(true, "Successfully saved notes.", "success");
			} catch (error) {
				renderToastContent(true, "Failed to save notes.", "danger");
			}
		},
		[contactId, renderToastContent, setNotesForContact],
	);

	const onChangeDisposition = async (event) => {
		let newDisposition = [];
		let newSubDisposition = [];

		if (event.length) {
			const selectedDisposition = event[0];
			setSubDispositionOptions(selectedDisposition.subDispositions || []);
			newSubDisposition = getSubDispositionByIdOrDefault(selectedDisposition.subDispositions, null);
			newDisposition = [selectedDisposition];
		}
		setDisposition(newDisposition);
		setSubDisposition(newSubDisposition);
		await saveNotes(newDisposition, newSubDisposition, notes);
	};

	const onChangeSubDisposition = async (event) => {
		let newSubDisposition = [];

		if (event.length) {
			newSubDisposition = [event[0]];
		}

		setSubDisposition(newSubDisposition);
		await saveNotes(disposition, newSubDisposition, notes);
	};

	return (
		<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
			<div style={{ padding: "15px", display: "flex", width: "100%" }}>
				<div style={{ padding: "10px", width: "100%" }}>
					<label>Disposition:</label>
					<Typeahead
						clearButton
						id="disposition"
						labelKey="dispositionName"
						onChange={(e) => onChangeDisposition(e)}
						options={dispositionOptions}
						placeholder="Choose a disposition..."
						onFocus={(e) => e.target.select()}
						emptyLabel="No dispositions found"
						selected={disposition}
					/>
				</div>
				<div style={{ padding: "10px", width: "100%" }}>
					<label>Sub-disposition:</label>
					<Typeahead
						clearButton
						id="sub-disposition"
						labelKey="subDispositionName"
						onChange={(e) => onChangeSubDisposition(e)}
						options={subDispositionOptions}
						placeholder="Choose a sub-disposition..."
						onFocus={(e) => e.target.select()}
						emptyLabel="No sub-dispositions found"
						selected={subDisposition}
					/>
				</div>
			</div>
			<div style={{ padding: "0px 25px", display: "flex", flexDirection: "column", flex: 1 }}>
				<label>Notes:</label>
				<textarea
					className="form-control"
					style={{
						width: "100%",
						resize: "none",
						padding: "10px",
						flex: 9,
					}}
					value={notes}
					onBlur={() => saveNotes(disposition, subDisposition, notes)}
					maxLength={NOTES_CHAR_LIMIT}
					onChange={(e) => handleNoteChange(e.target.value)}
				></textarea>
				<div style={{ textAlign: "right", flex: 1 }}>
					<label style={{ fontSize: "12px", marginTop: "2px" }}>
						{notes !== "" ? noteCharLimit + " characters remaining." : null}
					</label>
				</div>
			</div>
		</div>
	);
};
export default ContactNotes;
